import { lazy } from "react";
import FormNetworkMarketerForm from "../pages/MLM/FormNetworkMarketer/Form";
import FormNetworkMarketerList from "../pages/MLM/FormNetworkMarketer/List";
import StepStairCommissionList from "../pages/MLM/StepStairCommission/List";
// const FormNetworkMarketerForm = lazy(() =>
//   import("../pages/MLM/FormNetworkMarketer/Form")
// );
// const FormNetworkMarketerList = lazy(() =>
//   import("../pages/MLM/FormNetworkMarketer/List")
// );

const fRMsRoutes = [
  {
    type: "add",
    key: Math.ceil(Math.random()) * 100000,
    path: "/form-network-marketer/add",
    element: <FormNetworkMarketerForm observe={false} edit={false} fromDraft={false} />,
  },
  {
    type: "edit",
    key: Math.ceil(Math.random()) * 100000,
    path: "/form-network-marketer/edit/:id",
    element: <FormNetworkMarketerForm observe={false} edit={true} fromDraft={false} />,
  },
  {
    key: Math.ceil(Math.random()) * 100000,
    path: "/form-network-marketer",
    element: <FormNetworkMarketerList />,
  },
  {
    key: Math.ceil(Math.random()) * 100000,
    path: "/step-stair-commission",
    element: <StepStairCommissionList />,
  },
];

export default fRMsRoutes;
